//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- FUNÇÃO ASSÍNCRONA SALVAR EMPRESA ---------------//
// Responsável por salvar a empresa criada via API
export default async function loadTagsService(q) {
    if(q === null || q === undefined) q = ""
    try {
        const response = await api.get(`/tags?q=${q}`);
        return response;
    } catch {
        toast.error("Erro ao carregar tags");
        return null;
    }
}